import { render, staticRenderFns } from "./Return_RefundPolicy.vue?vue&type=template&id=0fcfe2db&scoped=true&"
import script from "./Return_RefundPolicy.vue?vue&type=script&lang=js&"
export * from "./Return_RefundPolicy.vue?vue&type=script&lang=js&"
import style0 from "./Return_RefundPolicy.vue?vue&type=style&index=0&id=0fcfe2db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcfe2db",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VContainer,VImg})
